module.exports = __webpack_public_path__ + "static/media/bg_5.5e967557.jpg";